function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#6159f8",
    r: 256,
    "data-original": "#046eff",
    style: {},
    className: ""
  })))))))))))))))))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m250.128 511.934c2.188.049 4.383.071 6.585.065 141.384-.394 255.68-115.328 255.286-256.713-.001-.36-.014-.717-.017-1.076l-163.141-163.141-5.789 22.658-22.657-22.657-5.789 22.657-22.657-22.657-5.789 22.657-22.66-22.658-5.789 22.657-22.657-22.657-5.79 22.658-22.657-22.657-8.237 20.209-20.21-20.21-3.656 40.57-42.809 42.809-42.693 5.779 17.435 17.435-17.435 11.012 19.252 19.252-19.252 9.194 17.698 17.698-17.698 10.749 18.902 18.902-18.902 9.545 17.348 17.348-17.348 11.099 21.215 21.215-21.23 7.116z",
    fill: "#574fdc",
    "data-original": "#0051be",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m374.263 165.227h48.736v15h-48.736z",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.263 335.908h48.736v15h-48.736z",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.263 307.462h48.736v15h-48.736z",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.263 279.015h48.736v15h-48.736z",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.263 250.568h48.736v15h-48.736z",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.263 222.121h48.736v15h-48.736z",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.263 193.674h48.736v15h-48.736z",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffd944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.002 165.227h48.736v15h-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.002 335.908h48.736v15h-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.002 307.462h48.736v15h-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.002 279.015h48.736v15h-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.002 250.568h48.736v15h-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.002 222.121h48.736v15h-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.002 193.674h48.736v15h-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 91.069 3.75 22.959-3.75 25.778h-7.5v-48.737z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m146.292 107.937h48.736v15h-48.736z",
    fill: "#ffd944",
    transform: "matrix(0 -1 1 0 55.222 286.097)",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.973 107.937h48.736v15h-48.736z",
    transform: "matrix(0 -1 1 0 225.904 456.778)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.526 107.937h48.736v15h-48.736z",
    transform: "matrix(0 -1 1 0 197.457 428.332)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.079 107.937h48.736v15h-48.736z",
    transform: "matrix(0 -1 1 0 169.01 399.885)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.382 111.687h48.736v7.5h-48.736z",
    transform: "matrix(0 -1 1 0 144.313 375.188)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m203.185 107.937h48.736v15h-48.736z",
    fill: "#ffd944",
    transform: "matrix(0 -1 1 0 112.116 342.991)",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.739 107.937h48.736v15h-48.736z",
    fill: "#ffd944",
    transform: "matrix(0 -1 1 0 83.669 314.544)",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 376.33 3.75 22.959-3.75 25.777h-7.5v-48.736z",
    fill: "#ffd944",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m146.292 393.198h48.736v15h-48.736z",
    fill: "#ffd944",
    transform: "matrix(0 -1 1 0 -230.038 571.358)",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.973 393.198h48.736v15h-48.736z",
    transform: "matrix(0 -1 1 0 -59.357 742.039)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.526 393.198h48.736v15h-48.736z",
    transform: "matrix(0 -1 1 0 -87.804 713.592)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.079 393.198h48.736v15h-48.736z",
    transform: "matrix(0 -1 1 0 -116.251 685.146)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.382 396.948h48.736v7.5h-48.736z",
    transform: "matrix(0 -1 1 0 -140.948 660.449)",
    fill: "#ffcc00",
    "data-original": "#ffcc00",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m203.185 393.198h48.736v15h-48.736z",
    fill: "#ffd944",
    transform: "matrix(0 -1 1 0 -173.145 628.252)",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.739 393.198h48.736v15h-48.736z",
    fill: "#ffd944",
    transform: "matrix(0 -1 1 0 -201.592 599.805)",
    "data-original": "#ffd944",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 386.331h-128.263v-256.526h128.263l64.132 137.327z",
    fill: "#00ddc1",
    "data-original": "#00ddc1",
    style: {},
    className: ""
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 129.805h128.263v256.526h-128.263z",
    fill: "#00baa0",
    "data-original": "#00baa0",
    style: {},
    className: ""
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 350.908h-92.84v-185.681h92.84l46.421 99.402z",
    fill: "#00eecf",
    "data-original": "#00eecf",
    style: {},
    className: ""
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 165.227h92.841v185.681h-92.841z",
    fill: "#00ddc1",
    "data-original": "#00ddc1",
    style: {},
    className: ""
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.842 294.015h-75.696v-71.894h15v56.894h60.696z",
    fill: "#00baa0",
    "data-original": "#00baa0",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m289.33 228.102c-14.848 0-26.928-12.08-26.928-26.928s12.08-26.927 26.928-26.927 26.927 12.079 26.927 26.927-12.079 26.928-26.927 26.928zm0-38.855c-6.577 0-11.928 5.351-11.928 11.927 0 6.577 5.351 11.928 11.928 11.928 6.576 0 11.927-5.351 11.927-11.928 0-6.576-5.351-11.927-11.927-11.927z",
    fill: "#00baa0",
    "data-original": "#00baa0",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m214.666 292.495c-14.848 0-26.928-12.08-26.928-26.928s12.08-26.927 26.928-26.927 26.928 12.079 26.928 26.927-12.08 26.928-26.928 26.928zm0-38.854c-6.577 0-11.928 5.351-11.928 11.927 0 6.577 5.351 11.928 11.928 11.928s11.928-5.351 11.928-11.928-5.351-11.927-11.928-11.927z",
    fill: "#00ddc1",
    "data-original": "#00ddc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m305.395 310.689h15v50.221h-15z",
    fill: "#00baa0",
    "data-original": "#00baa0",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m222.166 250.567h-15v-41.893h-54.007v-15h69.007z",
    fill: "#00ddc1",
    "data-original": "#00ddc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m153.159 307.462h102.841v15h-102.841z",
    fill: "#00ddc1",
    "data-original": "#00ddc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 307.462h19.428v15h-19.428z",
    fill: "#00baa0",
    "data-original": "#00baa0",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m289.33 189.247c-6.577 0-11.928 5.351-11.928 11.927 0 6.577 5.351 11.928 11.928 11.928 6.576 0 11.927-5.351 11.927-11.928 0-6.576-5.351-11.927-11.927-11.927z",
    fill: "#dbe1e8",
    "data-original": "#dbe1e8",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.666 253.641c-6.577 0-11.928 5.351-11.928 11.927 0 6.577 5.351 11.928 11.928 11.928s11.928-5.351 11.928-11.928-5.351-11.927-11.928-11.927z",
    fill: "#f7f9fa",
    "data-original": "#f7f9fa",
    style: {},
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.e7caabe7.svg";
export { ForwardRef as ReactComponent };